import type { StatsParams } from '@empathybroker/tsclient-stats/dist/models/params/stats-params'

import type { ActionContext } from 'vuex'
import type { ActionClass, AnalyticsState, PeriodsData } from '../../../models'

import { StatsReportsIdsEnum } from '@empathybroker/tsclient-stats/dist/enums/stats-reports-ids.enum'

import { LoadDistDataAction } from '../actions/load-dist-data.action'
import { ANALYTICS_CONSTS } from '../analytics.consts'

export class LoadSessionsDataAction implements ActionClass {
  static async execute(
    this: void,
    { dispatch, commit, state }: ActionContext<AnalyticsState, any>,
    filters?: StatsParams['filters'],
  ): Promise<void> {
    const currentSessionsData = state.data.overall.sessions
    const reportId = StatsReportsIdsEnum.DAILY_SESSION
    const newSessionsData: Partial<PeriodsData> = {}
    const params: any = {
      ...(filters && Object.keys(filters).length && { filters }),
    }
    if (!currentSessionsData?.currentPeriod) {
      newSessionsData.currentPeriod = await dispatch(ANALYTICS_CONSTS.actions.fetchStatsReport, {
        id: reportId,
        params,
      })
    }
    const periodToCompare = LoadDistDataAction.getPeriodToCompare()
    if (!!periodToCompare && !currentSessionsData?.[periodToCompare]) {
      const periodToCompareDates = LoadDistDataAction.getPeriodToCompareDates(periodToCompare)
      newSessionsData[periodToCompare] = await dispatch(ANALYTICS_CONSTS.actions.fetchStatsReport, {
        id: reportId,
        params: {
          ...params,
          startDate: periodToCompareDates[0],
          endDate: periodToCompareDates[1],
        },
      })
    }
    if (Object.keys(newSessionsData).length) {
      commit(ANALYTICS_CONSTS.mutations.setSessionsData, {
        data: newSessionsData,
      })
    }
  }
}
